import { useMutation } from "@apollo/client/react";
import React, { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import SAVE_ARCHIVO_VISITA from "../data/graphQL/mutations/Visitas/saveArchivoVisita";

const VisitaContext = createContext();

export const VisitaProvider = ({ initialValue, children }) => {
  const [visita, setVisita] = useState(initialValue);

  const [saveArchivoVisita, { data: dataArchivo }] = useMutation(SAVE_ARCHIVO_VISITA, {});

  useEffect(() => {
    if (!dataArchivo) return;
    if (dataArchivo.saveArchivoVisita.success)
      toast.success('Archivo guardado correctamente');
  }, [dataArchivo]);

  return (
    <VisitaContext.Provider value={{ visita, setVisita, saveArchivoVisita }}>
      {children}
    </VisitaContext.Provider>);

};

export const useVisita = () => {
  const context = useContext(VisitaContext);
  if (!context) {
    toast.error("useVisita debe usarse dentro de un VisitaProvider");
    throw new Error("useVisita debe usarse dentro de un VisitaProvider");
  }
  return context;
};